import { images } from '../constants'; 

const events = [  
    {
        id: 1,
        image: images.event1,
        title: "Otwarcie Muzeum Ogrodnictwa",
        details: {
            date: "gru,2026",
            location: "Dwór Imielno",
        },
        gallery: [
            images.event1Gallery1,
        ],
    },
    {
        id: 2,
        image: images.event2,
        title: "Start programu Gądziak w ogrodzie",
        details: {
            date: "mar,2027",
            location: "Dwór Imielno",
        },
        gallery: [
            images.event1Gallery1,
        ],
    },
];

export default events;